var _rect, _path, _path2, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChargerOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EB4E20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8508 18.3359L20.4291 25.133C20.3787 25.1869 20.3463 25.2527 20.3358 25.3228C20.3252 25.3929 20.337 25.4643 20.3697 25.5285C20.4024 25.5927 20.4546 25.6471 20.5202 25.6852C20.5858 25.7232 20.662 25.7434 20.7398 25.7433H23.5916V31.6693L30.0133 24.8722C30.0637 24.8183 30.0961 24.7525 30.1067 24.6824C30.1172 24.6123 30.1054 24.5409 30.0727 24.4767C30.0401 24.4125 29.9878 24.3581 29.9222 24.3201C29.8566 24.282 29.7804 24.2618 29.7026 24.2619H26.8508V18.3359Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0013 19V24.3333H29.668L23.668 31V25.6667H20.668L27.0013 19Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 45,
    height: 45,
    rx: 22.5,
    stroke: "#EB4E20",
    strokeOpacity: 0.2,
    strokeWidth: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargerOn);
export default __webpack_public_path__ + "static/media/chargerOn.6de17c236c08ecbc533137da797b04bf.svg";
export { ForwardRef as ReactComponent };